import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import './QuoteCarousel.css';

const quotes = [
  {
    text: "Wyborcy to nie są meble, które można przesuwać z lewej na prawą stronę. <br/>" +
        "<strong>Tych, którzy złożyli tę nadzieję w moje ręce, chcę zaprosić do tego, by zaufali Rafałowi Trzaskowskiemu.</strong>",
    author: "Szymon Hołownia",
    source: "https://x.com/PL_2050/status/1924850997106495605"
  },
  {
    text: "Nie mam wątpliwości, że należy postawić tamę skrajnej prawicy w jej marszu po władzę. " + 
    "Traktuję poważnie zobowiązanie Rafała Trzaskowskiego do budowy solidarnej, otwartej, demokratycznej Polski. " +
    "(...). <br/><strong>Ja dysponuję tylko jednym głosem i oddam go na Rafała Trzaskowskiego. " +
    "Apeluję do lewicowych wyborców, by zrobili to samo.</strong>",
    author: "Magda Biejat",
    source: "https://x.com/MagdaBiejat/status/1924797757669114207"
  },
  {
    text: "I tu musi być dobra współpraca między rządem a prezydentem. " + 
      "Między ministrem obrony narodowej a zwierzchnikiem Sił Zbrojnych. " + 
      "<br/><strong>Ja deklaruję pełną współpracę z prezydentem Rafałem Trzaskowskim</strong>",
      author: "Władysław Kosiniak-Kamysz",
      source: "https://x.com/KosiniakKamysz/status/1924462046738784270"
  },
  {
    text: "<strong>Nawrocki zrobił rzecz całkowicie obrzydliwą. Przejął mieszkanie od starszej i schorowanej osoby, nie płacąc za nie.</strong> (...) " +
    "<br/>Bronienie złodziejstwa jest wbrew interesom Polski, wbrew interesom prawicy, jest wbrew prawdzie i jakimkolwiek zasadom. Może i jest zgodne z interesem PiS, " +
    "ale oznacza to, że <strong>ten interes jest zupełnie sprzeczny z interesem Polski, prawicy, sprzeczny z zasadami.</strong>",
    author: "Sławomir Mentzen",
    source: "https://x.com/SlawomirMentzen/status/1919812286631612451"
  },
];

export function QuoteCarousel() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * quotes.length));
  const [isHovered, setIsHovered] = useState(false);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    let interval;
    if (!isHovered) {
      interval = setInterval(() => {
        setIndex((prevIndex) => (prevIndex + 1) % quotes.length);
      }, 10000);
    }
    return () => clearInterval(interval);
  }, [isHovered]);

  return (
    <div 
      className="quote-carousel-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        controls={true}
        indicators={false}
        fade
        interval={null}
      >
        {quotes.map((quote, idx) => (
          <Carousel.Item key={idx}>
            <div className="quote-content">
              <p className="quote-text" dangerouslySetInnerHTML={{ __html: quote.text }} />
              <p className="quote-author">
                — <a href={quote.source} target="_blank" rel="noopener noreferrer">{quote.author}</a>
              </p>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
} 